export const CUSTOM_OPTIONS_GET_REQUEST = 'CUSTOM_OPTIONS_GET_REQUEST';
export const CUSTOM_OPTIONS_GET_SUCCESS = 'CUSTOM_OPTIONS_GET_SUCCESS';
export const CUSTOM_OPTIONS_GET_ERROR = 'CUSTOM_OPTIONS_GET_ERROR';
export const CUSTOM_OPTIONS_ONCHANGE = 'CUSTOM_OPTIONS_ONCHANGE';
